import { Contact } from "@prisma/client";
import axios from "axios";

export async function createContact(data: Omit<Contact, "id">) {
  const response = await axios.post("/api/contact", data);
  return response.data;
}

export async function updateContact(id: string, data: Partial<Contact>) {
  const response = await axios.patch(`/api/contact/${id}`, data);
  return response.data;
}

export async function deleteContact(id: string) {
  const response = await axios.delete(`/api/contact/${id}`);
  return response.data;
}
